<template>
  <portal to="modals">
    <free-plan-modal
      v-if="showModal"
      :message="freePlanMessage"
      @close="closeModal"
    />
    <add-users-modal
      v-if="showUsersModal"
      :user="loggedInUser()"
      :message="freePlanMessage"
      @close="closeUsersModal"
    />
    <mobile-app-popup-modal />
    <YoutubeModal />
    <RequestFeatureModal />
    <ReportIssueModal />
    <SessionLimitationModal v-if="sessionLimitationModalVisible && isLoggedIn" />
  </portal>
</template>

<script>
  import { eventBus } from '@/_legacy/eventBus';
  import FreePlanModal from '@/_legacy/components/Modals/NotAvailableOnFreePlanModal.vue';
  import AddUsersModal from '@/_legacy/components/Modals/AddUsersModal.vue';
  import authMixin from '@/_legacy/mixins/authMixin';
  import MobileAppPopupModal from '@/ui/pages/MobileAppPopupModal.vue';
  import YoutubeModal from '@/ui/components/resourceCenter/YoutubeModal.vue';
  import RequestFeatureModal from '@/ui/components/resourceCenter/RequestFeatureModal.vue';
  import ReportIssueModal from '@/ui/components/resourceCenter/ReportIssueModal.vue';
  import SessionLimitationModal from '@/ui/pages/SessionLimitationModal.vue';
  import { isSessionLimitationEnabled } from '@/ui/helpers/featureHelper';
  import emitter from '@/services/emitter';
  import { loggedIn } from '@/ui/auth/auth';

  export default {
    components: {
      ReportIssueModal,
      RequestFeatureModal,
      AddUsersModal,
      FreePlanModal,
      MobileAppPopupModal,
      YoutubeModal,
      SessionLimitationModal
    },

    mixins: [authMixin],

    data() {
      return {
        showModal: false,
        showUsersModal: false,
        sessionLimitationModalVisible: false,
        freePlanMessage: {
          text: this.$t('This feature is not included in your free plan.'),
          advice: this.$t('Upgrade now to unlock the full potential of Lumiform'),
        },
      };
    },

    computed: {
      isLoggedIn() {
        return loggedIn.value;
      },
    },

    created() {
      emitter.on('sessionLimitReached', this.showSessionLimitationModal);
      emitter.on('sessionLimitReachedReset', this.resetSessionLimitationModal);
      eventBus.$on('free-plan-limit', this.showFreePlanModal);
      eventBus.$on('add-users', this.showAddUsersModal);
    },

    beforeDestroy() {
      emitter.off('sessionLimitReached', this.showSessionLimitationModal);
      emitter.off('sessionLimitReachedReset', this.resetSessionLimitationModal);
      eventBus.$off('free-plan-limit', this.showFreePlanModal);
      eventBus.$off('add-users', this.showAddUsersModal);
    },

    methods: {
      showSessionLimitationModal() {
        if (isSessionLimitationEnabled()) {
          this.sessionLimitationModalVisible = true;
        }
      },

      resetSessionLimitationModal() {
        if (isSessionLimitationEnabled()) {
          this.sessionLimitationModalVisible = false;
        }
      },

      showFreePlanModal({ message, shouldRedirect }) {
        if (message) {
          this.freePlanMessage = message;
        }
        this.shouldRedirect = shouldRedirect || false;
        this.showModal = true;
      },

      showAddUsersModal({ message }) {
        if (message) {
          this.freePlanMessage = message;
        }
        this.showUsersModal = true;
      },

      closeModal() {
        this.showModal = false;
        if (this.shouldRedirect) {
          if (this.canGoBack) {
            this.$router.go(-1);
          } else {
            this.$router.push({ name: 'root' });
          }
        }
      },

      closeUsersModal() {
        this.showUsersModal = false;
      },
    },
  };
</script>
